"use strict";

import 'regenerator-runtime/runtime'

export function collectUserAnswerForQueue() {
    let block = document.querySelector('.user-answer-queue');

    if (block == null) {
        return;
    }
 
    let queueUrl = block.getAttribute('data-queue-url');
    let answerType = document.querySelector('.game-answers a') ? 'predefined' : 'userInput';
    let queueDestination = block.getAttribute('data-queue-destination');

    let rmqData = {
        type: 'user_answer',
        data: [
            block.getAttribute('data-pageload-datetime'),
            new Date(),
            window.__uuid,
            block.getAttribute('data-offer-url-id'),
            block.getAttribute('data-user-country'),
            block.getAttribute('data-user-device-type'),
            block.getAttribute('data-session-id'),
            block.getAttribute('data-content-token'),
            block.getAttribute('data-question-token'),
        ]
    };

    let kafkaData = {
        type: 'user_answer',
        data: [
            parseInt(block.getAttribute('data-pageload-datetime-ms')),
            Date.now(),
            window.__uuid,
            block.getAttribute('data-offer-url-id'),
            block.getAttribute('data-user-country'),
            block.getAttribute('data-user-device-type'),
            block.getAttribute('data-session-id'),
            block.getAttribute('data-content-token'),
            block.getAttribute('data-question-token'),
        ]
    };

    if (answerType === 'predefined') {
        const answersButtons = document.querySelectorAll(".game-answers a");
        const isAppDownloadModal = document.querySelector('.app-download');

        answersButtons.forEach(button => {
            button.addEventListener("click", function (event) {
                let urlToRedirect = event.target.href;
                let isButtonWithRewarded = button.classList.contains('with-rewarded-video');
                let isShowUserAnswers = document.querySelector('.question-page-other-people-answered');
                let isQuizUniverseAnswers = document.querySelector('.quiz-universe-answers');

                if (urlToRedirect === undefined) {
                    urlToRedirect = event.target.parentNode.href;
                }

                if (urlToRedirect) {
                    if (!isButtonWithRewarded && !window._GRV_available) {
                        event.preventDefault();
                    }

                    // format: ({answer-token}, {answer-via-input}:<empty>, {timestamp})
                    rmqData.data.push(urlToRedirect.split('/').pop(), '', new Date());
                    kafkaData.data.push(urlToRedirect.split('/').pop(), '', Date.now());
                    saveData();

                    if (button.classList.contains('js-aw') || isButtonWithRewarded || isShowUserAnswers || isQuizUniverseAnswers || isAppDownloadModal) {
                        return;
                    }

                    window.location.href = urlToRedirect;
                }
            });
        });
    } else {
        document.querySelector('.game-answer-input').onsubmit = function (event) {
            event.preventDefault();

            // format: ({answer-token}:<empty>, {answer-via-input}, {timestamp})
            rmqData.data.push('', document.querySelector('.game-answer-input input[name="answer"]').value, new Date());
            kafkaData.data.push('', document.querySelector('.game-answer-input input[name="answer"]').value, Date.now());
            saveData();
            document.querySelector('.game-answer-input').submit();
        }
    }

    function saveData() {
        if (!hasRecordedAnswer()) {
            localStorage.setItem('qBrokerURL', queueUrl);
            localStorage.setItem('qDestination', queueDestination);
            localStorage.setItem('qDataRMQ', JSON.stringify(rmqData));
            localStorage.setItem('qDataKafka', JSON.stringify(kafkaData));
        }
    }

    function hasRecordedAnswer() {
        return !!localStorage.getItem('qDataRMQ') && !!localStorage.getItem('qDataKafka');
    }
}

export function sendUserAnswerToQueue() {
    const brokerUrl = localStorage.getItem('qBrokerURL');
    const destination = localStorage.getItem('qDestination');
    const _rmqData = localStorage.getItem('qDataRMQ');
    const _kafkaData = localStorage.getItem('qDataKafka');

    if (!brokerUrl || !destination || !_rmqData || !_kafkaData) {
        cleanStorage();
        return;
    }

    const client = new StompJs.Client({
        brokerURL: brokerUrl,
        reconnectDelay: 0,
        heartbeatIncoming: 0,
        heartbeatOutgoing: 0
    });

    sendDataToKafka(JSON.parse(_kafkaData).data, 'answers');
    sendData().finally(() => cleanStorage());

    function cleanStorage () {
        localStorage.removeItem('qBrokerURL');
        localStorage.removeItem('qDestination');
        localStorage.removeItem('qDataRMQ');
        localStorage.removeItem('qDataKafka');
    }

    function sendData() {
        return new Promise(function (resolve, reject) {
            client.activate();

            client.onConnect = function (frame) {
                client.publish({
                    destination: destination,
                    headers: {persistent: true},
                    body: _rmqData
                });
                
                client.deactivate();
                resolve(true);
            };
        });
    }
}

export function sendSpendDataToQueue() {
    let partnerEncryptValue = Cookies.get('partner_encrypt');
    if (!partnerEncryptValue) { return; }

    const meta = document.querySelector('meta[name="tracking"]');
    if (!meta) { return; }

    const client = new StompJs.Client({
        brokerURL: meta.dataset.brokerUrl,
        reconnectDelay: 0,
        heartbeatIncoming: 0,
        heartbeatOutgoing: 0
    });

    let data = {
        server_timestamp: meta.dataset.serverTime,
        session_id: meta.dataset.sessionId,
        partner_encrypt: partnerEncryptValue,
        country: meta.dataset.country,
        offer_url_id: meta.dataset.offerUrlId,
        ext_id: meta.dataset.extId,
        device_type: meta.dataset.device,
    };

    client.activate();

    client.onConnect = function (frame) {
        let _data = Object.entries(data).map((v) => v[1]);
        _data.splice(0,1);
        _data.unshift(parseInt(meta.dataset.serverTimeMilliseconds));

        sendDataToKafka(_data, 'taboola_spend');
        client.publish({
            destination: 'taboola_spend',
            headers: {persistent: true},
            body: JSON.stringify(data)
        });
        client.deactivate();
    };

    Cookies.remove('partner_encrypt');
}